var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-label": "chevron-down-icon",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11.204 18.882-9.11-9.11a1.125 1.125 0 0 1 0-1.59l1.063-1.063a1.125 1.125 0 0 1 1.589-.002L12 14.337l7.253-7.22a1.125 1.125 0 0 1 1.59.002l1.062 1.062c.44.44.44 1.152 0 1.591l-9.11 9.11c-.44.44-1.152.44-1.591 0"
  })));
};
export default SvgChevronDown;